module.exports = __webpack_public_path__ + "static/media/union.c1d0e097.svg";